import React from 'react'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
// core components
import GridItem from 'components/Grid/GridItem.jsx'
import Card from 'components/Card/Card.jsx'
import CardAvatar from 'components/Card/CardAvatar.jsx'
import CardBody from 'components/Card/CardBody.jsx'

import appIcon from 'assets/app/orekami/app-icon.png'

const styles = {
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
}

function UserProfile(props) {
  const { classes } = props
  return (
    <Grid container>
      <GridItem xs={12} sm={12} md={12}>
        <Card profile>
          <CardAvatar profile>
            <a href="#pablo" onClick={e => e.preventDefault()}>
              <img src={appIcon} alt="..." />
            </a>
          </CardAvatar>
          <CardBody profile>
            <h4 className={classes.cardTitle}>君の目の前で万能になった俺が神になる</h4>
            <p className={classes.description}>
              チャットUI＋ターン制＋仲間（スキル）組み合わせのバトルゲーム第二弾
            </p>

            <p>
              ゲーム紹介/攻略:{' '}
              <a href="https://appget.com/appli/view/73357/">アプリゲット</a>
            </p>

            <a href="https://itunes.apple.com/jp/app/i-god/id1465366515?mt=8">
              <img
                src={require('assets/img/appstore-badge.svg')}
                alt="AppStoreで入手"
                height="40"
                style={{ margin: '10px 10px' }}
              />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.firebaseapp.horieapp.god">
              <img
                src={require('assets/img/google-play-badge.png')}
                alt="Google Play で手に入れよう"
                width="153"
              />
            </a>
          </CardBody>
        </Card>
      </GridItem>
    </Grid>
  )
}

export default withStyles(styles)(UserProfile)
